import React, { useEffect, useState, useContext} from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { Row, Col } from 'react-flexbox-grid'
import { Button, Card, Form, Icon, Image, Input, Message, Divider } from 'semantic-ui-react'
import { passRestore, resetPassRestore } from '../actions/actionCreators'
import Logo from '../images/logo-admin.png'
import { Text, Translate, LanguageContext } from '../helpers/language';
import { NotificationManager } from 'react-notifications';

const LoginRestore = (props) => {

  const languageContext = useContext(LanguageContext);

  const [email, changeEmail] = useState(props.auth.isLogged && props.auth.user.email ? props.auth.user.email : '');
  const [restore, changeRestore] = useState(false);

  const message = props.passwordRestore.message ? Translate(languageContext, props.passwordRestore.message) : '';
  const messageStatus = props.passwordRestore.success ? true : false;
  const is_logged = props.auth.isLogged;


  useEffect(() => { 
    //if there are some errors display and reset
    if (message && !messageStatus) {
      props.dispatch(resetPassRestore())
      NotificationManager.error(message);
    } else if (message) {
      props.dispatch(resetPassRestore())
      NotificationManager.success(message);
    }
  });

  const restorePassword = (event) => {
    event.preventDefault()
    changeRestore(true);
    window.dataLayer.push({
      event: 'user_event',
      eventProps: {
        category: 'user_action',
        action: 'password_restore_request',
        label: 'User Password Restore Request',
        value: 'true'
      }
    });
 		props.dispatch(passRestore( {email: email} ))
  }
  
  const handleEmailChange = (event) => {
    changeEmail(event.target.value);
  }
  
  return (
    <div className="lisia-dialog lisia-centered-dialog">
        <Row center="xs">
          <Col className="password-restore-wrapper" xs={11} sm={9} md={7} lg={3}>
            <Card fluid={true} raised={true} centered={true}>
              <Card.Content>
                <div className="passwordRestoreForm">
                  <Image size='small' src={ Logo } className='m-b-10'/>
                  <Form onSubmit={restorePassword}>
                    <h3 className='text-center'><Text tid='restore_password' /></h3>         
                    <Divider />
                    <Form.Field>
                      {!is_logged && <label><Text tid="restore_password_description" /></label>}
                      {!is_logged ? 
                        <Input type="email" value={email} name="email" onChange={handleEmailChange} placeholder={Translate(languageContext,'email')} />:
                        <Input type="email" disabled={true} value={email} name="email" onChange={handleEmailChange} placeholder={Translate(languageContext,'email')} />
                      }
                    </Form.Field>                    
                    <h5><Text tid="restore_password_instructions" /></h5>                      
                    <Button style={{width: '100%'}} type="submit" className='lisia-blue'>
                      <Icon name='checkmark' /> <Text tid="restore_password_send" />
                    </Button>                        
                    <Divider />
                    <div className='footer'>
                      {is_logged ? 
                      <Link to="/profile" style={{float: 'left'}}>
                        <Text tid="back_to_profile" />
                      </Link>:
                      <Link to="/" style={{float: 'left'}}>
                        <Text tid="back_to_login" />
                      </Link>
                      }
                    </div>
                  </Form>
                </div>
              </Card.Content>
            </Card>
          </Col>
        </Row>          
    </div>
  )  
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  passwordRestore: state.passwordRestore
})

export default connect(mapStateToProps)(LoginRestore)
